export default {
  state: {
    // 初始化账号信息
    account: {
      name: "",
      account: "",
      roles: [],
      avatar: "",
    },
    // 租户信息
    tenant: {
      uid: "",
      roles: [],
    },
    // token
    token: "",
    // public-key
    publicKey: "",
    // secret-key
    secretKey: "gdsBuTD32zp5ORYXfx7tHATmF0FjCnE7",
  },
  mutations: {
    // 设置token
    setToken: (state: any, token: string) => {
      state.token = token;
    },

    // 处理状态
    setAccount: (state: any, account: any) => {
      state.account.name = account.name;
      state.account.account = account.account;
      state.account.roles = account.roles;
      state.account.avatar = account.avatar;
    },

    // 处理租户
    setTenant: (state: any, tenant: any) => {
      state.tenant.uid = tenant.uid;
      state.tenant.roles = tenant.roles;
    },

    // 设置公钥
    setPublicKey: (state: any, publicKey: string) => {
      state.publicKey = publicKey;
    },

    // 清空数据
    resetState: (state: any) => {
      state.account = {
        name: "",
        account: "",
        roles: [],
        avatar: "",
      };
      state.tenant = {
        uid: "",
        role: "",
      };
      state.token = "";
    },
  },
};
